// services/changesService.js
import api from "./api";

export const getSiteChanges = async (id) => {
  try {
    const response = await api.get(`/site-changes/${id}/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching site changes:", error);
    throw error;
  }
};

export const getProbeChanges = async (id) => {
  try {
    const response = await api.get(`/probe-changes/${id}/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching probe changes:", error);
    throw error;
  }
};

// Optional: Add these helper methods if needed
export const getAllSiteChanges = async () => {
  try {
    const response = await api.get("/site-changes/");
    return response.data;
  } catch (error) {
    console.error("Error fetching all site changes:", error);
    throw error;
  }
};

export const getAllProbeChanges = async () => {
  try {
    const response = await api.get("/probe-changes/");
    return response.data;
  } catch (error) {
    console.error("Error fetching all probe changes:", error);
    throw error;
  }
};
